import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetChatsErrorAction implements Action {
  public static readonly type = 'GetChatsErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetChatsErrorAction.type;
}
